module.exports = __webpack_public_path__ + "static/media/checkmark.4053f6ae.svg";